import HowToParticipate from "./how-to-participate";

const participatePageRoutes = [{ path: "/como-participar", element: <HowToParticipate /> }];

export default participatePageRoutes;
